
import { useNavigate } from "react-router-dom";
import icons from "../../../../../../Data/icons";



const SingleEmployesAttachments = ({
  id,
  name,
  type,
  expired_at,
  status,
  openModal,

}) => {
  const navigate = useNavigate()
  const EyeIcon = icons.eye;
  const EditPen = icons.pen


  return (
    <>
      <tr className="text-center">
        <td>{id}</td>
        <td>{type}</td>
        <td>{expired_at}</td>
        <td>{status}</td>
       
        <td>
          <button className="btn" onClick={() => openModal(id)}>
            <EyeIcon />
          </button>
          <button className="btn" onClick={()=>navigate(`${process.env.PUBLIC_URL}/updateattachments/${id}`)}>
         <EditPen/>
          </button>
        </td>
      </tr>
    </>
  );
};

export default SingleEmployesAttachments;
